import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  useRecordContext,
} from "react-admin";

import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";
import LayoutContainer from "../components/LayoutContainer";
import PaymentChannelField from "../components/PaymentChannelsField";
import PermissionChecker from "../../../components/PermissionChecker";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import { Typography } from "@material-ui/core";
import VoidField from "../components/VoidField";
import exporter from "../../../utils/exporter";
import useDataGridStyles from "../components/DataGridStyle";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     overflow: "auto",
//   },
// }));

const PaymentHistoryList = (props) => {
  const title = "transactions";
  const headers = [
    { source: "status", label: "Status" },
    { source: "transaction_no", label: "Tran No." },
    { source: "member.firstname", label: "Name" },
    { source: "payment_channels", label: "Payment Method" },
    { source: "total_revenue", label: "Amount" },
    { source: "earn.reward", label: "Earn Reword" },
    { source: "redeem.reward", label: "PAC" },
    { source: "last_adjust_amount.reward", label: "Adjust" },
    { source: "create_local_time", label: "Date" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Transactions" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        filter={{
          from: "2000-01-01",
          to: "2700-12-31",
          //event_code: "NEW_PAYMENT",
          bill_detail: { $ne: null },
        }}
        sort={{ field: "create_local_time", order: "DSC" }}
        exporter={(data) => exporter(data, headers, title)}
        classes={{ content: classes.content }}
        actions={<CustomAction types={["Export"]} />}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <VoidField />
          <TextField label={"Transaction No."} source="transaction_no" />

          <MemberTextField label="Name" source="member.firstname" />

          <PaymentChannelField
            label={"Payment Method"}
            source={"payment_channels"}
          />
          <FunctionField
            label="Amount"
            render={(record) =>
              `${record.total_revenue + (record.delivery_cost ?? 0)}`
            }
          />
          {/* <TextField label="Amount" source="total_revenue" /> */}
          <FunctionField
            label="Earn point"
            render={(record) =>
              `${Object.values(record.earn).reduce(
                (total, cur) => total + cur,
                0
              )}`
            }
          />

          <TextField label="PAC" source="redeem.reward" />
          <TextField label="Adjust" source="last_adjust_amount.reward" />
          <CustomDateField label="Date" source="create_local_time" />
          {/* <DateField source="create_local_time" label="Date" type="date" /> */}
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Payment_History" />
    </LayoutContainer>
  );
};

const MemberTextField = (props) => {
  const { source, label } = props;
  const record = useRecordContext(props);

  return (
    <>
      {record.member?.firstname ? (
        <TextField label={label} source={source} />
      ) : (
        <Typography>Walk-in</Typography>
      )}
    </>
  );
};
export default PaymentHistoryList;
